  <div class="position-relative we-card-wrapper">
    <div class="position-absolute w-100 h-100 prod-masking-div"
      *ngIf="eventListing?.channel?.content_visibility?.display == 0 ||eventListing?.channel?.content_visibility?.display == 2 || eventListing?.hl?.mcnt">
      <app-product-masking-card  
        [content_visibility]="eventListing?.channel?.content_visibility" [communityVisible]="eventListing?.hl?.mcnt">
      </app-product-masking-card>
    </div>
    <div class="cursor-pointer"
      (click)="navigateToDetail(eventListing?.event_id)"
      [eventTracker]="{category: callingfrom,action: mls.googleEventText.event_card.key4,product_type: eventListing.product_type,product_id: eventListing.product_type_id}">
      <img loading="lazy" class="post-pic-bnnr top-radius w-100 post-pic"
        src="{{eventListing?.event_banner_list[0]?.file_url| fitInImg : igs.imageGroup.fitin_300x200}}"
        onerror="this.src='assets/themes/images/banner-placeholder-lg.svg'" />
    </div>
    <div class="p-3 cursor-pointer clearfix"
      (click)="navigateToDetail(eventListing?.event_id)"
      [eventTracker]="{category: callingfrom,action: mls.googleEventText.event_card.key4,product_type: eventListing.product_type,product_id: eventListing.product_type_id}">
      <div class="row">
        <div class="col-12 calc-58">
          <p class="mb-2"
            *ngIf="(eventListing.is_event_ended == 1 &&eventListing.is_going == 0) ||(eventListing.is_going == 1 && eventListing.is_event_ended == 1)">
            <span
              *ngIf="eventListing.is_event_ended == 1 && eventListing.is_going == 0"
              class="chip small outline text-white">
              {{ mls.languageText.event_card.key1}}
              <span *ngIf="mls?.is_lskey_display == 1">
                (event_card.key1)</span>
              </span>
            <span
              *ngIf="eventListing.is_going == 1 && eventListing.is_event_ended == 1"
              class="chip small bg-success text-white">
              {{ mls.languageText.event_card.key2}}
              <span *ngIf="mls?.is_lskey_display == 1">
                (event_card.key2)</span>
              </span>
          </p>
          <p class="heading-4 pb-2">{{ eventListing?.event_name }}</p>
          <p class="secondary-paragraph pb-2">
            <span class="color-grey-500"> {{ eventListing?.title }}</span>
          </p>
        </div>
      </div>

      <p class="paragraph pb-2 clearfix">
        <span class="float-left calc-20">
          {{eventListing?.start_date| getDateTimeOnTimezone : eventListing.time_zone : "DWT"}}
          -{{eventListing?.end_date| getDateTimeOnTimezone : eventListing.time_zone : "DWT"}}
          ({{ eventListing?.time_zone }})
        </span>
      </p>
      <div class="pb-4">
      <p class="secondary-paragraph pb-4">
        <span class="float-left color-grey-700 calc-20">
          {{eventListing?.location}}
        </span>
      </p>
    </div>
      <div> 
        <span class="secondary-paragraph-bold"
          *ngIf="eventListing?.number_days != 0">
          <span class="color-grey-500">
            {{ eventListing?.number_days }}
            {{ mls.languageText.event_card.key13 }}</span>
          <span *ngIf="mls?.is_lskey_display == 1">(event_card.key13)</span>
        </span>
        <span class="float-right clearfix">
          <span class="secondary-paragraph">{{ eventListing?.total_registered }}
          {{ mls.languageText.event_card.key4}}
          </span><span *ngIf="mls?.is_lskey_display == 1">
            (event_card.key4)</span>
          </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12 brdr-top py-3">
        <div class="d-flex jstify">
          <button *ngIf="this.mls.featureOnOffList.featureList.share.value || !mls.userLoginFlow"
            class=" mx-2 btn-design small outline cursor-pointer"
            (click)="productShare()"
            [eventTracker]="{category: callingfrom,action: mls.googleEventText.event_card.key2,product_type: eventListing.product_type,product_id: eventListing.product_type_id}">
            {{ mls.languageText.event_card.key6}}
            <span *ngIf="mls?.is_lskey_display == 1">(event_card.key6)</span>
          </button>
          <button
            [ngClass]="{' mx-2 ':  (eventListing?.is_going == 1 )|| eventListing?.is_certificate != 1}"
            (click)="navigateToDetail(eventListing?.event_id)"
            [eventTracker]="{category: callingfrom,action: mls.googleEventText.event_card.key4,product_type: eventListing.product_type,product_id: eventListing.product_type_id}"
            class="mx-2 btn-design small outline cursor-pointer">
            {{ mls.languageText.event_card.key5}}
            <span *ngIf="mls?.is_lskey_display == 1">(event_card.key5)</span>
          </button>
          <button
            *ngIf="eventListing?.is_certificate == 1"
            (click)="showcertificateList(eventListing?.event_id)"
            [eventTracker]="{category: callingfrom,action: mls.googleEventText.event_card.key4,product_type: eventListing.product_type,product_id: eventListing.product_type_id}"
            class="btn-design  small filled mx-2 ellipsis cursor-pointer">
            View Certificate<span *ngIf="mls?.is_lskey_display == 1">
              (event_card.key5)</span>
          </button>
          <button
              *ngIf="showGreenGoing == false && eventListing?.is_certificate != 1 && eventListing?.is_going != 1 && eventListing?.is_event_ended == 0"
              class="mx-2 btn-design small filled cursor-pointer"
              (click)="markGoing(eventListing?.event_id)"
              [eventTracker]="{category: callingfrom,action: mls.googleEventText.event_card.key3,product_type: eventListing.product_type,product_id: eventListing.product_type_id}">
             {{ mls.languageText.event_card.key7}}
            <span *ngIf="mls?.is_lskey_display == 1">(event_card.key7)</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- information message popup start-->
  <app-action-modal  
    *ngIf="isActionModalShown == true"
    (resetActionModal)="resetActionModal($event)"
    [isActionModalShown]="isActionModalShown"
    [actionData]="actionData">
  </app-action-modal>
  <!-- information message popup end-->